export default {"src":"/_next/static/media/TOAST_WARNING.79f25028.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};